/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Day_Names_SundayInputs */

const fr_week_session_day_names_sunday = /** @type {(inputs: Week_Session_Day_Names_SundayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dim`)
};

/**

* @param {Week_Session_Day_Names_SundayInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_day_names_sunday = /** @type {((inputs?: Week_Session_Day_Names_SundayInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Day_Names_SundayInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_day_names_sunday(inputs)
});